import styled, { css } from 'styled-components'
import SubmitButton from '../../../../Components/Form/SubmitButton'

export const StyledTableActionCellWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`

export const StyledDeleteConversionsButton = styled(SubmitButton)`
  width: 230px;
  border-radius: 16px !important;
  text-transform: none !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 20px !important;
  align-self: flex-end;
`

const commonStyles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 24px;
  border-radius: 8px;
`

export const StyledAllDeletedStatus = styled.div`
  ${commonStyles}
  background-color: rgba(255, 121, 141, 0.24);
  color: #de2f4c;
`

export const StyledUnpaidDeletedStatus = styled.div`
  ${commonStyles}
  background-color: rgba(0, 132, 13, 0.12);
  color: #00840d;
`

export const StyledPaidDeletedStatus = styled.div`
  ${commonStyles}
  background-color: rgba(151, 71, 255, 0.12);
  color: #9747ff;
`

export default {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    marginTop: '56px',
  },
  fileUploaderWrapper: {
    width: '700px',
  },
  operation: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '23px',
  },
  leftOperation: {
    display: 'flex',
    gap: '24px',
  },
  downloadSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginLeft: '24px',
  },
  reportType: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    color: '#798498',
    fontWeight: 700,
    lineHeight: '18px',

    '& > svg': {
      width: '18px',
      height: '20px',
      '& > path': {
        fill: 'currentColor',
      },
    },
  },
  download: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    color: '#00112B',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '20px',

    '&:hover': {
      textDecoration: 'none',
      color: '#00112B',
    },
  },
  setting: {
    padding: '12px !important',
    borderRadius: '12px',
  },
  upload: {
    position: 'relative',
    width: '200px',
    borderRadius: '16px',
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '20px',
    marginLeft: '16px',
  },
  disableButton: {
    backgroundColor: '#C2C8D1',
    '&:hover': {
      backgroundColor: '#C2C8D1',
      filter: 'none',
    },
  },
  uploadIcon: {
    position: 'absolute',
    left: '14px',
  },
  childrenWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
    width: '100%',
    padding: '20px 40px',
  },
}
